<template>
  <v-row justify="center">
    <v-dialog v-model="showModal" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Bucket</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-alert
              text
              prominent
              dismissible
              v-model="alertShow"
              type="error"
              icon="mdi-alert"
            >{{ alertText }}</v-alert>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Print SCP AE-Title"
                    v-model="aeTitle"
                    :class="{'disable-events': !savingEnable}"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-combobox
                    label="Equipments AE-Titles"
                    v-model="equipments"
                    :class="{'disable-events': !savingEnable}"
                    multiple
                    chips
                    dense
                  ></v-combobox>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    label="Paper Size"
                    v-model="paperSize"
                    :items="paperSizeItems"
                    :class="{'disable-events': !savingEnable}"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    label="Color"
                    v-model="colorPrinting"
                    :items="colorPrintingItems"
                    :class="{'disable-events': !savingEnable}"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    label="Border"
                    v-model="border"
                    :items="borderItems"
                    :class="{'disable-events': !savingEnable}"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    label="Empty Image"
                    v-model="emptyImage"
                    :items="emptyImageItems"
                    :class="{'disable-events': !savingEnable}"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" class="outlinedButton">
                  <v-btn
                    class="ma-2"
                    tile
                    outlined
                    color="red"
                    dense
                    v-show="deleteButton"
                    v-if="savingEnable"
                    @click="remove"
                  >
                    <v-icon left>mdi-delete</v-icon>Delete Bucket
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="hide" text>Close</v-btn>
          <v-btn color="darken-1" @click="save" :disabled="!valid" v-if="savingEnable" text>Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  name: "PrinterBucketModal",
  data: () => ({
    id: null,
    action: null,
    valid: true,
    alertShow: false,
    alertText: null,
    showModal: false,
    // printer values
    name: "",
    aeTitle: "",
    equipments: [],
    paperSize: null,
    paperSizeItems: [],
    colorPrinting: null,
    colorPrintingItems: [],
    border: null,
    borderItems: [],
    emptyImage: null,
    emptyImageItems: [],
    // action buttons
    deleteButton: false,
    savingEnable: false,
  }),
  mounted() {
    // Permissions
    let configuration = this.$store.getters.resources.configuration;

    if (configuration.print_server.update) {
      this.savingEnable = true;
    }

    // Printer enums
    this.paperSizeItems = this.$printServer.paperSize;
    this.colorPrintingItems = this.$printServer.colorPrinting;
    this.borderItems = this.$printServer.border;
    this.emptyImageItems = this.$printServer.emptyImage;
  },
  methods: {
    show(printerData, counter) {
      // set default options items

      if (printerData == null) {
        // new client
        this.deleteButton = false;
        this.id = counter;
        this.aeTitle = null;
        this.equipments = [];
        this.paperSize = "Client";
        this.colorPrinting = "Client";
        this.border = "Client";
        this.emptyImage = "Client";
        this.action = "new";
      } else {
        // update client
        this.deleteButton = true;
        this.id = printerData.id;
        this.aeTitle = printerData.aeTitle.trim();
        this.equipments = printerData.equipments;
        this.paperSize = printerData.paperSize;
        this.colorPrinting = printerData.colorPrinting;
        this.border = printerData.border;
        this.emptyImage = printerData.emptyImage;
        this.action = "update";
      }

      this.showModal = true;
    },
    hide() {
      this.loading = false;
      this.showModal = false;
    },
    save() {
      this.$emit(this.action, {
        id: this.id,
        aeTitle: this.aeTitle,
        equipments: this.equipments,
        paperSize: this.paperSize,
        colorPrinting: this.colorPrinting,
        border: this.border,
        emptyImage: this.emptyImage,
      });
      this.hide();
    },
    remove() {
      this.action = "remove";
      this.save();
    },
    checkNested(obj, level, ...rest) {
      if (obj === undefined) return false;
      if (rest.length == 0 && {}.hasOwnProperty.call(obj, level)) return true;
      return this.checkNested(obj[level], ...rest);
    },
  },
};

</script>

<style scoped>
  .v-alert {
    overflow: hidden;
  }
  .disable-events {
    pointer-events: none;
  }
</style>